import { Header } from "@components/site/Header"
import { ContentBlocks } from "eddev/blocks"
import { defineView } from "eddev/views"

export const meta: ViewMeta = {
  templateName: "Home Page",
}

export default defineView("template-home", (props) => {
  return (
    <>
      <Header noPattern />
      <div className="relative w-full">
        <ContentBlocks blocks={props.page?.contentBlocks} />
      </div>
    </>
  )
})
